module.exports = __webpack_public_path__ + "components/flag/static/square/sl-62d06a12083f7d38925e188ae7368c4e.svg";